import React from 'react';
import { Column, Row } from '@upgrade/react-components';
import { Trans } from '@lingui/react';
import { useLocaleSwitcherExperiment } from '../../../utils/locale';
import LocaleSwitcherDropdown from './LocaleSwitcherDropdown';
import { Text } from '../TypographyPublicSite';
import { LocaleFooterMenuContainer } from './styles';

const LocaleFooterMenu = () => {
  const { isExperimentEnabled } = useLocaleSwitcherExperiment();

  if (!isExperimentEnabled) {
    return null;
  }

  return (
    <>
      <Text bold className="footer-menu__category" as="h3">
        <Trans id="footer.regionAndLanguage" message="Region & Language" />
      </Text>
      <Row xsHorizontalAlign="center" mdHorizontalAlign="start">
        <Column xsHorizontalAlign="center" mdHorizontalAlign="start">
          <LocaleFooterMenuContainer>
            <LocaleSwitcherDropdown />
          </LocaleFooterMenuContainer>
        </Column>
      </Row>
    </>
  );
};

export default LocaleFooterMenu;
